import { useEffect, useState } from 'react';
import { fetchAnalytics } from '../../services/adminApi';
import Loader from '../../components/admin/ui/Loader';
import Table from '../../components/admin/ui/Table';

const PATH_COLUMNS = [
  { key: 'value', label: 'Page', render: (row) => row.path },
  { key: 'count', label: 'Vues' }
];

const VALUE_COLUMNS = [
  { key: 'value', label: 'Valeur' },
  { key: 'count', label: 'Vues' }
];

function DailyBarChart({ daily }) {
  if (!daily.length) return null;
  const max = Math.max(...daily.map((d) => d.count), 1);
  return (
    <div className="admin-analytics-bars">
      {daily.map((d) => (
        <div className="admin-analytics-bar-col" key={d.day} title={`${d.day} : ${d.count} vue${d.count > 1 ? 's' : ''}`}>
          <div className="admin-analytics-bar" style={{ height: `${(d.count / max) * 100}%` }} />
        </div>
      ))}
    </div>
  );
}

function AdminAnalyticsPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchAnalytics().then(setData);
  }, []);

  if (!data) return <Loader label="Chargement des statistiques..." />;

  const cards = [
    { label: 'Vues — 7 derniers jours', value: data.total7d },
    { label: 'Visiteurs uniques — 7 derniers jours', value: data.uniqueVisitors7d },
    { label: 'Vues — 30 derniers jours', value: data.total30d },
    { label: 'Visiteurs uniques — 30 derniers jours', value: data.uniqueVisitors30d }
  ];

  return (
    <section className="admin-section">
      <h2>Analytics</h2>
      <p className="admin-muted">
        Statistiques agrégées, sans cookie ni identifiant persistant — les visiteurs uniques sont
        déduits d'une empreinte anonyme qui change chaque jour (IP + navigateur + date), jamais
        stockée en clair ni envoyée au navigateur.
      </p>

      <div className="admin-dashboard-grid">
        {cards.map((card) => (
          <div key={card.label} className="admin-dashboard-card">
            <span className="admin-dashboard-value">{card.value}</span>
            <span className="admin-dashboard-label">{card.label}</span>
          </div>
        ))}
      </div>

      <div className="admin-panel">
        <h3>Vues par jour — 30 derniers jours</h3>
        <DailyBarChart daily={data.daily} />
      </div>

      <div className="admin-dashboard-panels">
        <div className="admin-panel">
          <h3>Pages les plus visitées</h3>
          <Table columns={PATH_COLUMNS} rows={data.topPaths} rowKey="path" emptyMessage="Pas encore de données." />
        </div>
        <div className="admin-panel">
          <h3>Navigateurs</h3>
          <Table columns={VALUE_COLUMNS} rows={data.browsers} rowKey="value" emptyMessage="Pas encore de données." />
        </div>
      </div>

      <div className="admin-dashboard-panels">
        <div className="admin-panel">
          <h3>Systèmes</h3>
          <Table columns={VALUE_COLUMNS} rows={data.os} rowKey="value" emptyMessage="Pas encore de données." />
        </div>
        <div className="admin-panel">
          <h3>Pays</h3>
          <Table columns={VALUE_COLUMNS} rows={data.countries} rowKey="value" emptyMessage="Pas encore de données." />
        </div>
      </div>
    </section>
  );
}

export default AdminAnalyticsPage;
